export default `<!DOCTYPE html>
<html>
  <head>
    <title>Hello world</title>
    {listener}
  </head>
  <body>
    Name: <input type="text" value="{payload}" />
  </body>
</html>
`;
